import {ManagedModelType} from 'models/ManagedModelDefinitions';
import {modelInaccessible} from 'models/ManagedModelsReduxActions';
import {Thunk} from 'redux-stores/Store';
import * as net from 'util/Net';

import {RequestSampleStatusCounts} from './fulfillments/FulfillmentConstants';
import {Request} from './RequestConstants';
import * as RequestDAO from './RequestDAO';

export enum RequestActionType {
  REQUEST_LIST_V2_COMPLETED = 'REQUEST_LIST_V2_COMPLETED',
  REQUESTS_FETCH_COMPLETED = 'REQUESTS_FETCH_COMPLETED',
}

interface RequestListV2CompletedArgs {
  requests: Array<Request>;
  sampleStatusCountsByRequestId: {[requestId: string]: RequestSampleStatusCounts};
  requestedTaskSchemaIdsByRequestId: {[requestId: string]: Array<string>};
}

type RequestListV2CompletedAction = RequestListV2CompletedArgs & {
  type: RequestActionType.REQUEST_LIST_V2_COMPLETED;
};

export function requestListV2Completed({
  requests,
  sampleStatusCountsByRequestId,
  requestedTaskSchemaIdsByRequestId,
}: RequestListV2CompletedArgs): RequestListV2CompletedAction {
  return {
    type: RequestActionType.REQUEST_LIST_V2_COMPLETED,
    requests,
    sampleStatusCountsByRequestId,
    requestedTaskSchemaIdsByRequestId,
  };
}

export interface RequestsFetchCompletedAction {
  type: RequestActionType.REQUESTS_FETCH_COMPLETED;
  requests: Array<Request>;
}
export function requestsFetchCompleted(requests: Array<Request>): RequestsFetchCompletedAction {
  return {
    type: RequestActionType.REQUESTS_FETCH_COMPLETED,
    requests,
  };
}

export function openRequest(requestId: string): Thunk<Promise<void>> {
  return async (dispatch) => {
    try {
      const {request} = await RequestDAO.fetchRequest(requestId);
      dispatch(requestsFetchCompleted([request]));
    } catch (e) {
      if (net.isServerRequestError(e) && e.status === 404) {
        dispatch(modelInaccessible(ManagedModelType.REQUEST_BY_ID, {[requestId]: e.responseJSON}));
      } else {
        throw e;
      }
    }
  };
}

export type RequestAction = RequestListV2CompletedAction | RequestsFetchCompletedAction;
